// extracted by mini-css-extract-plugin
export default {"loader":"cl1Rb","fadeIn":"rYUC1","loader__logo":"WakaB"};